<template>
  <div id="rating-average-by-month" class="w-full" />
  <TheNoResult
    v-if="noData"
    :image="imgUrl"
    :title="$t('pages.review.reviewAnalyticsPage.chart.noResults.title')"
    :description="$t('pages.review.reviewAnalyticsPage.chart.noResults.description')"
  />
</template>

<script>
import TheNoResult from '@/components/layout/TheNoResult.vue'
import { AnalyticsAreaChart } from '@/components/charts/AnalyticsAreaChart'
import useNumber from '@/composables/number'
import useReview from '@/composables/review'
import ApexChart from 'apexcharts'

export default {
  components: {
    TheNoResult
  },
  setup() {
    const { roundNumber } = useNumber()
    const { reviewStatistics } = useReview()
    const imgUrl = computed(() => `${import.meta.env.VITE_AWS_STORAGE_URL}/review-analytics/review-average-rating.png`)

    return {
      roundNumber,
      reviewStatistics,
      imgUrl
    }
  },
  data: () => {
    return {
      chartInstance: null,
      chart: new AnalyticsAreaChart(),
      formattedData: []
    }
  },
  computed: {
    noData() {
      return this.formattedData[0]?.data.length === 0 || this.data.rating_value_average === 0
    },
    data() {
      return this.reviewStatistics.ratingAverageByMonth
    }
  },
  mounted() {
    this.initChart()
  },
  beforeUnmount() {
    if (this.chartInstance) {
      this.chartInstance.destroy()
    }
  },
  methods: {
    initChart() {
      this.formatData()
      if (!this.noData) {
        const chartElement = this.createElement('rating-average-by-month')
        this.chart.setColor(['#F8D169'])
        this.chart.setSeries(this.formattedData)
        this.chartInstance = new ApexChart(chartElement, this.chart.options)
        this.chartInstance.render()
      }
    },
    createElement(ref) {
      let elem = document.getElementById(ref)
      let chartElement = document.createElement('div')
      chartElement = elem.appendChild(chartElement)
      chartElement.setAttribute('id', `${ref}-apex`)
      return chartElement
    },
    formatData() {
      let formattedData = [
        {
          name: this.$t('pages.review.reviewAnalyticsPage.ratingAverageByMonth.series'),
          data: []
        }
      ]
      if (this.noData) {
        return
      }
      this.data.forEach((d) => {
        const date = `${this.$t(`global.months.${d.month}`)} ${d.year}`

        formattedData[0].data.push({
          x: date,
          y: d.rating_value_average_by_month ? this.roundNumber(d.rating_value_average_by_month, 1) : 0
        })
      })
      this.formattedData = formattedData
    }
  }
}
</script>
